import React, { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import Slide81 from "assets/images/TheSolutionImages/Slide8/Slide81.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function Slide8() {
  const [showScrollIcon, setShowScrollIcon] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isSmallScreen = window.innerWidth < 1300;

      const isIpadProLandscape =
        window.innerWidth >= 1350 &&
        window.innerWidth <= 1370 &&
        window.innerHeight >= 1000 &&
        window.innerHeight <= 1050;

      setShowScrollIcon(isSmallScreen || isIpadProLandscape);
    };

    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <MDBox textAlign="left" px={{ xs: 2, md: 4 }} width="100%">
      <MDBox
        width="100%"
        maxWidth={{ xs: "100%", md: "95%", lg: "1320px" }}
        height={{ xs: "auto", md: "540px" }}
        margin="0 auto"
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        gap={4}
        px={{ xs: 2, md: 3 }}
        py={3}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0)",
          borderRadius: "12px",
        }}
      >
        {/* Left Column - Text */}
        <MDBox
          flex="1"
          minWidth={0}
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          height="100%"
          maxHeight="100%"
          pr={1}
          color="white"
        >
          <h1
            style={{
              fontSize: "clamp(24px, 5vw, 32px)",
              fontWeight: "bold",
              marginBottom: "16px",
              color: "white",
            }}
          >
            SharpWatch® Eco-System
          </h1>

          {/* Scrollable Text Area */}
          <MDBox
            fontSize={{ xs: "18px", md: "24px" }}
            lineHeight={1.6}
            sx={{
              maxHeight: "320px",
              overflowY: "auto",
              pr: 1,
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <div style={{ marginBottom: "16px", color: "white", fontSize: "24px" }}>
              Turning data into decisions, enterprise-wide
            </div>

            <ul style={{ paddingLeft: "24px", margin: 0, color: "white", fontSize: "20px" }}>
              <li style={{ marginBottom: "12px" }}>Web HMI brings visibility to the browser.</li>
              <li style={{ marginBottom: "12px" }}>
                Reporting module builds operational dashboards.
              </li>
              <li style={{ marginBottom: "12px" }}>Alerting notifies key users automatically.</li>
              <li style={{ marginBottom: "12px" }}>
                LMS (Learning Management System) supports training.
              </li>
            </ul>
          </MDBox>

          {/* Scroll Indicator (responsive only) */}
          {showScrollIcon && (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={2}
              sx={{
                animation: "bounce 1.5s infinite",
                color: "#FFFFFF",
                fontSize: "30px",
              }}
            >
              <KeyboardArrowDownIcon fontSize="inherit" />
            </MDBox>
          )}
        </MDBox>

        {/* Right Column - Image */}
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={{ xs: "100%", md: "65%" }}
          maxWidth={{ xs: "100%", md: "900px" }}
          mt={{ xs: 3, md: 0 }}
        >
          <img
            src={Slide81}
            alt="SharpWatch Eco-System Decisions"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />
        </MDBox>
      </MDBox>

      {/* Keyframes for bounce animation */}
      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(5px); }
          }
        `}
      </style>
    </MDBox>
  );
}

export default Slide8;
